import { KCenterSpinner } from '@/ui-library/components/molecules/kLoaders';
import { KModal } from '@/ui-library/components';
import { useState, useRef } from 'react';
import { Box } from '@chakra-ui/react';

export const SlotsPreview = ({ previewData = null, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef(null);
  const iframeURL =
    import.meta.env.VITE_ENV === 'production'
      ? 'https://schedule.kula.ai/preview'
      : 'https://schedule.kulastg.com/preview';

  const initiateIFrameOnLoad = () => {
    console.log('initiateIFrameOnLoad');
    iframeRef.current?.contentWindow?.postMessage(
      { event: 'candidatePreview', data: previewData },
      '*'
    );
    setTimeout(() => {
      setIsLoading(false);
    }, 100);
  };

  const renderIframe = () => {
    return (
      <Box>
        {isLoading && <KCenterSpinner />}
        <Box opacity={isLoading ? 0 : 1}>
          <iframe
            ref={iframeRef}
            title="candidate-ui-preview"
            width="840px"
            height="580px"
            style={{ overflow: 'hidden' }}
            src={iframeURL}
            onLoad={initiateIFrameOnLoad}
          ></iframe>
        </Box>
      </Box>
    );
  };

  return (
    <KModal
      isOpen={true}
      title="Preview of candidate’s slot selection"
      onClose={onClose}
      ctaAction={() => {}}
      // eslint-disable-next-line react/no-children-prop -- pre-existing; behavior preserved (extraction move)
      children={renderIframe()}
      size="4xl"
      modalBodyProps={{
        maxHeight: '640px',
        overflow: 'hidden',
      }}
      footer={false}
    />
  );
};
